(function () {
  'use strict';

  // Live automatic discounts (Admin truth, UX only — do not invent %):
  // titles: "5% off" | "10% off" | "15% off" | "20% off"
  // minimum spend (original eligible line subtotal before %): $25 / $50 / $75 / $100
  var TIERS = [
    { min: 25, pct: 5 },
    { min: 50, pct: 10 },
    { min: 75, pct: 15 },
    { min: 100, pct: 20 }
  ];

  var EXCLUDE_HANDLES = {
    'halloween-3-pack-bundle': true,
    'fall-favorites-3-pack-bundle': true,
    'mothers-day-bestsellers-bundle': true,
    'party-explosion-5-pack-bundle': true,
    'flower-truck-5-pack-bundle': true,
    'succulent-5-pack-bundle-pop-up-cards': true,
    'love-birds-5-pack-bundle-pop-up-cards': true,
    'butterfly-5-pack-bundle-pop-up-cards': true,
    'fall-5-pack-bundle-pop-up-cards': true,
    'christmas-cards-5-pack-bundle': true,
    'dancing-santa-5-pack-bundle': true,
    'merry-christmas-5-pack-bundle': true,
    'the-christmas-list-set': true,
    'christmas-keepsake-3-pack-bundle': true
  };

  // PL 2026-10-09 better-of: a bundle line (has_components or pack heuristics) counts toward
  // the tiers ONLY if Shopify actually put a multi-buy tier discount on that line (cart truth).
  function hasTierAlloc(item) {
    var a = item.line_level_discount_allocations || [];
    for (var i = 0; i < a.length; i++) {
      var t = String((a[i].discount_application || {}).title || '').trim();
      for (var k = 0; k < TIERS.length; k++) if (t === TIERS[k].pct + '% off') return true;
    }
    return false;
  }

  var EXCLUDE_TAG_HINTS = ['aov bundle', '3-pack', '5-pack', 'bundle', 'exclude-multibuy'];

  function handleFromItem(item) {
    var handle = (item.handle || '').toLowerCase();
    if (handle) return handle;
    var url = (item.url || item.product_url || '').toLowerCase();
    var m = url.match(/\/products\/([^\/?#]+)/);
    if (m && m[1]) return decodeURIComponent(m[1]);
    return '';
  }

  function itemExcluded(item) {
    var handle = handleFromItem(item);
    if (EXCLUDE_HANDLES[handle]) return true;
    if (handle.indexOf('-bundle') !== -1 || handle.indexOf('-pack-') !== -1) return true;
    if (/^\d+-pack/.test(handle) || /pack-bundle/.test(handle)) return true;
    var title = (item.product_title || item.title || '').toLowerCase();
    if (/\b\d+-pack\b/.test(title) && /bundle/.test(title)) return true;
    if (/bundle for festive|card bundle|pack bundle/.test(title)) return true;
    var tags = item.tags;
    if (typeof tags === 'string') tags = tags.split(',');
    if (Array.isArray(tags)) {
      for (var t = 0; t < tags.length; t++) {
        var tag = String(tags[t] || '').toLowerCase().trim();
        for (var h = 0; h < EXCLUDE_TAG_HINTS.length; h++) {
          if (tag === EXCLUDE_TAG_HINTS[h] || tag.indexOf(EXCLUDE_TAG_HINTS[h]) !== -1) return true;
        }
      }
    }
    return false;
  }

  function eligibleFromCart(cart) {
    var eligibleCents = 0;
    var excludedOnly = true;
    var hasEligible = false;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if ((itemExcluded(it) || it.has_components) && !hasTierAlloc(it)) continue;
      excludedOnly = false;
      hasEligible = true;
      // Use original_line_price (pre-discount) so progress matches Admin minimums
      eligibleCents += it.original_line_price || it.final_line_price || 0;
    }
    if (!items.length) {
      return { eligibleCents: 0, excludedOnly: false, empty: true, hasEligible: false };
    }
    return {
      eligibleCents: eligibleCents,
      eligibleDollars: eligibleCents / 100,
      excludedOnly: excludedOnly && items.length > 0,
      empty: false,
      hasEligible: hasEligible
    };
  }

  function stateForSpend(dollars) {
    var unlocked = null;
    var next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (dollars >= TIERS[i].min) unlocked = TIERS[i];
      else if (!next) next = TIERS[i];
    }
    var progress = 0;
    if (!next && unlocked) progress = 100;
    else if (next) {
      var prevMin = unlocked ? unlocked.min : 0;
      var span = next.min - prevMin;
      progress = Math.max(0, Math.min(100, ((dollars - prevMin) / span) * 100));
    }
    var remain = next ? Math.max(0, next.min - dollars) : 0;
    var approxCards = remain > 0 ? Math.max(1, Math.ceil(remain / 13.99)) : 0;
    return {
      unlocked: unlocked,
      next: next,
      progress: progress,
      remain: remain,
      approxCards: approxCards,
      dollars: dollars
    };
  }

  function headline(st) {
    if (st.next && !st.unlocked) {
      return 'Add $' + st.remain.toFixed(2) + ' more for ' + st.next.pct + '% off';
    }
    if (st.next && st.unlocked) {
      return st.unlocked.pct + '% unlocked · Add $' + st.remain.toFixed(2) + ' more for ' + st.next.pct + '%';
    }
    if (st.unlocked && !st.next) {
      return st.unlocked.pct + '% off unlocked on eligible cards';
    }
    return 'Buy more cards, unlock automatic savings';
  }

  function subline(st) {
    if (st.next && st.approxCards) {
      return 'About ' + st.approxCards + ' more card' + (st.approxCards === 1 ? '' : 's') + ' at typical prices · Mix & match singles';
    }
    if (st.unlocked && !st.next) {
      return 'Best savings tier reached on eligible singles';
    }
    return 'Automatic at checkout · Fixed packs excluded';
  }

  function tierPillsHtml(st) {
    // Exactly one strong highlight: highest unlocked, or next goal if none unlocked.
    // Lower unlocked tiers are is-done (filled/muted). is-next is subtle only.
    return TIERS.map(function (t) {
      var cls = 'pl-mb__tier';
      if (st.unlocked && st.unlocked.pct === t.pct) {
        cls += ' is-active';
      } else if (st.unlocked && st.unlocked.pct > t.pct) {
        cls += ' is-done';
      } else if (!st.unlocked && st.next && st.next.pct === t.pct) {
        cls += ' is-active';
      } else if (st.next && st.next.pct === t.pct) {
        cls += ' is-next';
      }
      return '<span class="' + cls + '" data-pct="' + t.pct + '">$' + t.min + ' · ' + t.pct + '%</span>';
    }).join('');
  }

  function applyToDom(cart) {
    var meta = eligibleFromCart(cart);
    // Drawer footer "Total / Discount Total": show only when Shopify really applied a discount
    var hasDisc = (cart.total_discount || 0) > 0;
    document.querySelectorAll('.original_price_main, .discount_title').forEach(function (el) {
      el.style.display = hasDisc ? 'flex' : 'none';
    });
    var roots = document.querySelectorAll('[data-pl-multibuy]');
    roots.forEach(function (root) {
      var pageIsPack = root.getAttribute('data-pl-multibuy-page') === 'pack';
      if (pageIsPack) {
        root.hidden = true;
        root.setAttribute('aria-hidden', 'true');
        return;
      }
      if (meta.excludedOnly) {
        root.hidden = true;
        root.setAttribute('aria-hidden', 'true');
        return;
      }
      // Empty cart on cart page: keep bar visible with empty-state copy
      root.hidden = false;
      root.removeAttribute('aria-hidden');
      var st = stateForSpend(meta.eligibleDollars || 0);
      var h = root.querySelector('[data-pl-mb-headline]');
      var s = root.querySelector('[data-pl-mb-sub]');
      var fill = root.querySelector('[data-pl-mb-fill]');
      var tiers = root.querySelector('[data-pl-mb-tiers]');
      if (h) h.textContent = headline(st);
      if (s) s.textContent = subline(st);
      if (fill) fill.style.width = st.progress + '%';
      var legacyFill = root.querySelector('.progress-bar-fill');
      if (legacyFill) legacyFill.style.width = st.progress + '%';
      if (tiers) tiers.innerHTML = tierPillsHtml(st);
      var pTextLocal = root.querySelector('.progress-text');
      var pFirstLocal = root.querySelector('.progress-first-line');
      if (pTextLocal) pTextLocal.textContent = headline(st);
      if (pFirstLocal) {
        if (st.unlocked) pFirstLocal.textContent = 'You have ' + st.unlocked.pct + '% off on eligible cards';
        else pFirstLocal.textContent = 'Automatic multi-buy on eligible singles';
      }
    });

    var msgs = document.querySelectorAll('.message_count');
    var pFirsts = document.querySelectorAll('.progress-first-line');
    var pTexts = document.querySelectorAll('.progress-text');
    var cartProgresses = document.querySelectorAll('.cart-progress');
    if (meta.excludedOnly) {
      msgs.forEach(function (el) { el.textContent = ''; });
      cartProgresses.forEach(function (el) { el.style.display = 'none'; });
      return;
    }
    cartProgresses.forEach(function (el) { el.style.display = ''; });
    var st2 = stateForSpend(meta.eligibleDollars || 0);
    var line = headline(st2);
    msgs.forEach(function (el) { el.textContent = line; });
    pTexts.forEach(function (el) { el.textContent = line; });
    pFirsts.forEach(function (el) {
      if (st2.unlocked) el.textContent = 'You have ' + st2.unlocked.pct + '% off on eligible cards';
      else el.textContent = 'Automatic multi-buy on eligible singles';
    });
  }

  function pageLooksLikeDealPack() {
    if (document.querySelector('.product--deal-pack, .pl-bundle-callout')) return true;
    var path = (location.pathname || '').toLowerCase();
    if (path.indexOf('halloween-3-pack-bundle') !== -1) return true;
    var pm = path.match(/\/products\/([^\/?#]+)/);
    if (pm && EXCLUDE_HANDLES[decodeURIComponent(pm[1])]) return true;
    if (/-bundle\/?$/.test(path) || /-\d+-pack-/.test(path)) return true;
    if (/\/products\/[^\/]*pack[^\/]*bundle/.test(path)) return true;
    return false;
  }

  function ensurePackExclusionNote() {
    if (!pageLooksLikeDealPack()) return;
    if (document.querySelector('.pl-mb-pack-note')) return;
    var note = document.createElement('p');
    note.className = 'pl-mb-pack-note';
    note.setAttribute('data-pl-multibuy-pack-note', '');
    note.textContent = 'Packs do not count toward mix & match multi-buy. Singles do.';
    note.style.cssText = 'margin:0.75rem 0 1rem;font-size:13px;line-height:1.4;color:#6b5348;';
    var legacy = document.querySelector('.custom_note_text');
    if (legacy) {
      legacy.style.display = 'none';
      legacy.parentNode.insertBefore(note, legacy.nextSibling);
      return;
    }
    var qty = document.querySelector('.product-form__quantity, quantity-input, .product-form');
    if (qty && qty.parentNode) qty.parentNode.insertBefore(note, qty);
  }

  function ensureMbStyles() {
    var el = document.getElementById('pl-mb-styles');
    var css =
      '.pl-mb{margin:1rem 0 1.25rem;border:1px solid rgba(112,54,42,.18);border-radius:12px;background:linear-gradient(180deg,#fffaf6 0%,#f7efe8 100%);box-shadow:0 1px 0 rgba(255,255,255,.7) inset,0 8px 24px rgba(72,40,28,.06)}' +
      '.pl-mb__inner{padding:14px 16px 16px}' +
      '.pl-mb__eyebrow{font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#8a5a4a;font-weight:650;margin-bottom:4px}' +
      '.pl-mb__headline{font-size:16px;line-height:1.3;color:#3b241c;font-weight:700}' +
      '.pl-mb__sub{margin-top:4px;font-size:12.5px;color:#6b5348}' +
      '.pl-mb__track{margin-top:12px;height:8px;border-radius:999px;background:rgba(112,54,42,.12);overflow:hidden}' +
      '.pl-mb__fill{height:100%;width:0%;border-radius:inherit;background:linear-gradient(90deg,#70362a 0%,#a05a45 100%);transition:width .35s ease}' +
      '.pl-mb__tiers{display:flex;flex-wrap:wrap;gap:6px;margin-top:12px}' +
      '.pl-mb__tier{font-size:11px;font-weight:650;padding:4px 8px;border-radius:999px;border:1px solid rgba(112,54,42,.2);color:#70362a;background:#fff}' +
      '.pl-mb__tier.is-done{background:rgba(112,54,42,.08);color:#5a2c22}' +
      '.pl-mb__tier.is-active{background:#70362a;border-color:#70362a;color:#fff}' +
      '.pl-mb__tier.is-next{background:#fff;border-color:rgba(112,54,42,.45);color:#70362a}';
    if (!el) {
      el = document.createElement('style');
      el.id = 'pl-mb-styles';
      document.head.appendChild(el);
    }
    // Always refresh CSS text so prior dual-highlight rule cannot linger in SPA/cached sessions
    el.textContent = css;
  }

  function ensurePdpBar() {
    if (pageLooksLikeDealPack()) {
      var legacy = document.querySelector('.custom_note_text');
      if (legacy) legacy.style.display = 'none';
      ensurePackExclusionNote();
      return;
    }
    if (document.querySelector('.pl-mb')) return;
    var template = document.createElement('div');
    template.innerHTML = '' +
      '<div class="pl-mb" data-pl-multibuy data-pl-multibuy-page="single" role="region" aria-label="Multi-buy savings progress">' +
      '<div class="pl-mb__inner">' +
      '<div class="pl-mb__eyebrow">Mix &amp; match · Automatic at checkout</div>' +
      '<div class="pl-mb__headline" data-pl-mb-headline>Buy more cards, unlock automatic savings</div>' +
      '<div class="pl-mb__sub" data-pl-mb-sub>Automatic at checkout · Fixed packs excluded</div>' +
      '<div class="pl-mb__track" aria-hidden="true"><div class="pl-mb__fill" data-pl-mb-fill style="width:0%"></div></div>' +
      '<div class="pl-mb__tiers" data-pl-mb-tiers>' +
      '<span class="pl-mb__tier is-active">$25 · 5%</span>' +
      '<span class="pl-mb__tier">$50 · 10%</span>' +
      '<span class="pl-mb__tier">$75 · 15%</span>' +
      '<span class="pl-mb__tier">$100 · 20%</span>' +
      '</div></div></div>';
    var bar = template.firstChild;
    var note = document.querySelector('.custom_note_text');
    if (note) {
      note.classList.add('pl-mb-legacy-note');
      note.style.display = 'none';
      note.parentNode.insertBefore(bar, note.nextSibling);
    } else {
      var qty = document.querySelector('.product-form__quantity, quantity-input, .product-form');
      if (qty && qty.parentNode) qty.parentNode.insertBefore(bar, qty);
      else return;
    }
    ensureMbStyles();
  }

  function ensureCartBar() {
    var onCartPage = location.pathname === '/cart' || location.pathname.indexOf('/cart/') === 0;
    var hasDrawer = !!document.querySelector('cart-drawer, #CartDrawer');
    if (!onCartPage && !hasDrawer) return;
    var existing = document.querySelector('.cart-progress, [data-pl-multibuy-page="cart"]');
    if (existing) return;
    // Cart page: prefer top of items; drawer already renders progress-bar-cart snippet
    if (!onCartPage) return;
    var host =
      document.querySelector('#main-cart-items') ||
      document.querySelector('.cart__items, .cart-items, .cart__contents') ||
      document.querySelector('.cart__footer, .cart__blocks') ||
      document.querySelector('form[action="/cart"]') ||
      document.querySelector('cart-items .page-width, cart-items');
    if (!host) return;
    var wrap = document.createElement('div');
    wrap.className = 'cart-progress pl-mb-cart';
    wrap.setAttribute('data-pl-multibuy', '');
    wrap.setAttribute('data-pl-multibuy-page', 'cart');
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', 'Multi-buy savings progress');
    wrap.style.cssText = 'padding:14px 14px 16px;margin:12px 0 16px;background:linear-gradient(180deg,#fffaf6 0%,#f7efe8 100%);border:1px solid rgba(112,54,42,.18);border-radius:12px;text-align:left;';
    wrap.innerHTML = '' +
      '<p class="progress-first-line" style="font-size:13px;margin:0 0 6px;color:#3b241c;font-weight:650;">Automatic multi-buy on eligible singles</p>' +
      '<p class="progress-text" style="font-size:13px;margin:0 0 6px;color:#6b5348;font-weight:500;">Add more eligible cards to unlock savings</p>' +
      '<div class="progress-bar-container" style="height:8px;background:rgba(112,54,42,.12);border-radius:999px;width:100%;margin:10px 0 0;overflow:hidden;"><div class="progress-bar-fill" data-pl-mb-fill style="height:100%;width:0%;border-radius:inherit;background:linear-gradient(90deg,#70362a,#a05a45);transition:width .3s ease;"></div></div>' +
      '<div class="pl-mb__tiers" data-pl-mb-tiers style="display:flex;flex-wrap:wrap;gap:6px;margin-top:10px;"></div>' +
      '<div class="pl-mb__headline" data-pl-mb-headline style="display:none"></div>' +
      '<div class="pl-mb__sub" data-pl-mb-sub style="display:none"></div>';
    if (host.parentNode) host.parentNode.insertBefore(wrap, host);
    else host.insertBefore(wrap, host.firstChild);
  }

  function refresh() {
    ensureMbStyles();
    ensurePdpBar();
    ensurePackExclusionNote();
    ensureCartBar();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(applyToDom)
      .catch(function () {});
  }

  window.PLMultibuy = {
    TIERS: TIERS,
    refresh: refresh,
    eligibleFromCart: eligibleFromCart,
    stateForSpend: stateForSpend,
    itemExcluded: itemExcluded,
    handleFromItem: handleFromItem
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:change', refresh);
  // Theme pub/sub (Dawn-style) if present
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); });
    }
  } catch (e) {}
})();
